<template>
  <section class="companies flex flex-col lg:flex-row space-y-8 lg:space-y-0 lg:space-x-4 mb-10">
    <div
      v-if="role === roles.SUPER_ADMIN"
      class="admin lg:w-1/4 lg:mt-24"
    >
      <div class="info">
        <admin-info />
      </div>
    </div>

    <div
      class="al-tabs-container lg:w-full"
      :class="role === roles.SUPER_ADMIN ? '' : 'full-width'"
    >
      <div
        v-if="tabs.length > 1"
        class="al-tabs-title overflow-x-scroll overflow-y-hidden"
      >
        <template v-for="(tab) in tabs">
          <button
            :key="tab.id"
            class="button"
            :class="selectedTab === tab.id ? 'selected' : ''"
            @click="handleSelectTab(tab.id)"
          >
            {{ tab.title }}
          </button>
        </template>
      </div>
      <div class="al-tabs">
        <div
          v-if="selectedTab === allTabs.STATES"
          class="al-tab"
        >
          <states />
        </div>
        <div
          v-if="selectedTab === allTabs.LOCATIONS"
          class="al-tab"
        >
          <locations />
        </div>
        <div
          v-if="selectedTab === allTabs.CORPORATE_ADMINS"
          class="al-tab"
        >
          <corporate-admins />
        </div>
        <div
          v-if="selectedTab === allTabs.MANAGERS"
          class="al-tab"
        >
          <managers />
        </div>
        <div
          v-if="selectedTab === allTabs.SMS_TEMPLATE"
          class="al-tab"
        >
          <SMSTemplates />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Roles } from '@/constants';
import States from './States';
import Locations from './Locations';
import Managers from './Managers';
import AdminInfo from './AdminInfo';
import SMSTemplates from './SMSTemplates';
import CorporateAdmins from './CorporateAdmins';

const TABS = {
  STATES: 'STATES',
  LOCATIONS: 'LOCATIONS',
  MANAGERS: 'MANAGERS',
  CORPORATE_ADMINS: 'CORPORATE_ADMINS',
  SMS_TEMPLATE: 'SMS_TEMPLATE'
};

export default {
  name: 'StateLocation',
  components: {
    States,
    Locations,
    Managers,
    AdminInfo,
    SMSTemplates,
    CorporateAdmins
  },
  data() {
    return {
      role: this.$store.state.user.role,
      tabs: [],
      selectedTab: null,
      allTabs: TABS,
      roles: Roles
    };
  },
  mounted() {
    const self = this;
    this.generateTabs();
    this.$root.$on('showAddState', () => {
      self.$root.showLocationAdd = false;
      self.$root.showStateAdd = true;
      self.handleSelectTab(TABS.STATES);
    });
    this.$root.$on('showAddLocation', () => {
      self.$root.showLocationAdd = true;
      self.$root.showStateAdd = false;
      self.handleSelectTab(TABS.LOCATIONS);
    });
  },
  methods: {
    handleSelectTab(key) {
      this.selectedTab = key;
    },
    generateTabs() {
      const { role } = this;
      const isSuperAdmin = role === Roles.SUPER_ADMIN;
      // const isCorporateAdmin = role === Roles.ADMIN;

      const tabs = [];

      if (isSuperAdmin) {
        tabs.push({
          id: TABS.STATES,
          title: 'States',
          visible: true
        });
      }
      tabs.push({
        id: TABS.LOCATIONS,
        title: 'Locations',
        visible: true
      });
      tabs.push({
        id: TABS.CORPORATE_ADMINS,
        title: 'Corporate Admins',
        visible: true
      });
      tabs.push({
        id: TABS.MANAGERS,
        title: 'Managers',
        visible: true
      });
      if (isSuperAdmin) {
        tabs.push({
          id: TABS.SMS_TEMPLATE,
          title: 'SMS Templates',
          visible: true
        });
      }
      this.tabs = [...tabs];
      this.selectedTab = this.$root.showLocationAdd ? TABS.LOCATIONS : this.tabs[0].id;
    }
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-tooltip.min.css'></style>
<style scoped lang="scss">
  .companies {
      display: flex;

      .is-borderless {
          border: 0;
      }

      .admin {
          position: relative;

          .info {
              position: sticky;
              top: 0;
              z-index: 2;
          }
      }
  }
</style>
